/* Cierra el selector de idioma al pinchar fuera o al pulsar Escape.
 *
 * Solo eso. Abrir, cerrar con el raton y recorrer con el teclado ya lo hace <details> por
 * su cuenta, y el cambio de idioma lo hace el formulario: si este fichero no llegara a
 * cargarse, el selector sigue funcionando entero. Por eso va con defer y sin prisa.
 *
 * Hay DOS en la pagina (cabecera y cajon del movil), asi que al abrir uno se cierra el
 * otro: dos desplegables abiertos a la vez es un despiste, no una funcion.
 */
(function () {
  const abiertos = () => document.querySelectorAll('details[data-sc-idiomas][open]');

  // El Liquid arma el enlace de cada idioma con la RUTA de la pagina, sin lo que viniera
  // detras del `?`. No puede hacer otra cosa: el cajon del movil se sirve aparte con la
  // Section Rendering API y ahi la URL de la peticion no es la de la pagina. Aqui, que ya
  // estamos en el navegador, se sabe la de verdad, asi que se le devuelven los filtros y
  // la paginacion justo al pinchar. Sin este fichero el idioma cambia igual, solo que
  // volviendo a la pagina sin filtros.
  document.addEventListener('click', (evento) => {
    const enlace = evento.target.closest && evento.target.closest('.sc-idiomas__opcion');
    if (!enlace || !window.location.search) return;
    const destino = new URL(enlace.getAttribute('href'), window.location.origin);
    if (destino.search) return;
    destino.search = window.location.search;
    enlace.setAttribute('href', destino.pathname + destino.search);
  });

  document.addEventListener('click', (evento) => {
    abiertos().forEach((det) => {
      if (!det.contains(evento.target)) det.open = false;
    });
  });

  document.addEventListener('keydown', (evento) => {
    if (evento.key !== 'Escape') return;
    abiertos().forEach((det) => {
      det.open = false;
      const boton = det.querySelector('summary');
      // Devolver el foco al boton: si no, quien navega con teclado se queda en el limbo
      // detras del desplegable que acaba de cerrar.
      if (boton && det.contains(document.activeElement)) boton.focus();
    });
  });

  document.addEventListener('toggle', (evento) => {
    const det = evento.target;
    if (!det.matches || !det.matches('details[data-sc-idiomas]') || !det.open) return;
    abiertos().forEach((otro) => {
      if (otro !== det) otro.open = false;
    });
  }, true);
})();
